import { createStore, withProps } from '@ngneat/elf';
import { Ppm, PpmDto } from '@/types';
import { SelectOption } from '@/components/form-builder/form-builder.types';

export interface PpmStateProps {
  response: Ppm;
  dto?: Partial<PpmDto>;
  initialDto?: Partial<PpmDto>;
  totalEstimatedBudget: number;
  acsSelected?: SelectOption;
  comSelected?: SelectOption;
  comMemberSelected?: SelectOption;
  //dowbload
  download: {
    signPerson: string;
    function: string;
  };
  upload: {
    modelPpmFile: File[];
  };
  review: {
    comment: string;
    files: File[];
  };
}

export const ppmInitialDto: PpmDto = {
  nom: '',
  acId: undefined,
  annee: undefined,
  comId: undefined,
  ppmFiles: [],
  docIds: [],
  remarque: '',
  assigneeUserId: undefined,
};

export const ppmInitialState: PpmStateProps = {
  response: {
    id: 0,
    version: 0,
    ref: '',
    nom: '',
    annee: '',
    ac: { id: 0, nom: '', ancrage: '', contact: '', coms: [] },
    budgetEstime: undefined,
    status: '',
    realisations: [],
    docs: [],
    processInstanceId: null,
    remarque: '',
    actualise: false,
    nbrActualisation: 0,
    pvCpmp: [],
    extraitCpmp: [],

    documentCNCMPPermanente: [],
    documentCNCMPSpecialisee: [],
    documentCPMP: [],

    pvCncmpPermanente: [],
    pvCncmpSpecialisee: [],
    extraitCncmpPermanente: [],

    modelAlfrescoId: null,
    etapeProcess: null,
    avis: [],
  },
  dto: structuredClone(ppmInitialDto),
  initialDto: structuredClone(ppmInitialDto),
  totalEstimatedBudget: 0,
  acsSelected: { name: '', code: undefined },
  comSelected: { name: '', code: undefined },
  comMemberSelected: { name: '', code: undefined },
  download: {
    signPerson: '',
    function: '',
  },
  upload: {
    modelPpmFile: [],
  },
  review: {
    comment: '',
    files: [],
  },
};

export const ppmStateStore = createStore(
  { name: 'ppm-state' },
  withProps<PpmStateProps>({
    ...ppmInitialState,
  })
);
